import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { ChevronRight } from '@/components/atoms/assets/ChevronRight'

type ExploreMoreSlideProps = {
  onClick: () => void
}

export const ExploreMoreSlide: FC<ExploreMoreSlideProps> = ({ onClick }) => {
  const { t } = useTranslation('common')

  return (
    <div
      className={`flex flex-row shrink-0 w-[8.375rem] justify-center items-center cursor-pointer`}
      onClick={onClick}
    >
      <span className="text-sm text-primary font-bold mr-1">
        {t('discover.exploreMore')}
      </span>
      <ChevronRight />
    </div>
  )
}
